export default __webpack_public_path__ + "static/media/ushuaia.f84938b2.jpg";